module.exports = __webpack_public_path__ + "static/media/insta icon.873189ab.svg";